import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";

export default function Privacy() {
  return (
    <div className="min-h-screen navy-glow flex flex-col" data-testid="privacy-page">
      <Navbar variant="public" />
      <main className="flex-1">
        <section className="max-w-4xl mx-auto px-6 py-16">
          <div className="chip mb-6">Legal · Effective 2026</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
            Privacy <span className="text-brand">Policy</span>
          </h1>
          <p className="text-slate-400 mt-3">Last updated: February 2026</p>

          <div className="soft-card p-8 md:p-10 mt-10 space-y-8 text-slate-700 leading-relaxed">
            <Section title="Who we are">
              Yonsii Geek Support (“Yonsii”, “we”, “us”) is an independent tech-support service based in Dwarka, Delhi.
              This policy explains what personal data we collect when you book a session, how we use it, and the choices
              you have.
            </Section>

            <Section title="Data we collect">
              <ul className="list-disc pl-5 space-y-2">
                <li><strong>Account:</strong> your name, email address, and (optionally) phone number.</li>
                <li><strong>Session data:</strong> the issue you describe, the date/time slot you pick, and the resolution notes our technician writes.</li>
                <li><strong>Payment metadata:</strong> we store the amount and status of each session. We do not store card numbers on our servers.</li>
                <li><strong>Technical logs:</strong> IP address and browser type when you sign in, used for security and abuse prevention.</li>
              </ul>
            </Section>

            <Section title="How we use your data">
              <ul className="list-disc pl-5 space-y-2">
                <li>Deliver the technical support session you booked and keep a case log for you.</li>
                <li>Communicate with you about upcoming sessions, follow-ups, and receipts.</li>
                <li>Improve our service quality and train our technicians.</li>
                <li>Meet our legal, tax, and accounting obligations.</li>
              </ul>
              <p>We do <strong>not</strong> sell your data. We do not share your data with advertisers.</p>
            </Section>

            <Section title="Backup, storage & your rules">
              For services like Cloud Backup Setup, our technician works <em>inside your own accounts</em> (Google Drive,
              iCloud, OneDrive). We never copy your files to Yonsii servers. If we need temporary access, you grant it
              explicitly during the session and can revoke it the moment we hang up. You retain full ownership of every
              file, folder, and backup we help configure.
            </Section>

            <Section title="Tech-support standards">
              Every Yonsii session is bound by four rules:
              <ul className="list-disc pl-5 space-y-2 mt-2">
                <li>The technician identifies themselves at the start of the call.</li>
                <li>We never ask for banking passwords, OTPs, or seed phrases.</li>
                <li>We never install software on your device without confirming with you first.</li>
                <li>We hand you a case log with everything we did.</li>
              </ul>
            </Section>

            <Section title="Liability limits">
              Yonsii's total liability for any single session is capped at the amount paid for that session. We are not
              liable for pre-existing hardware failures, third-party service outages (ISPs, cloud providers), or data
              already lost before we begin our work. Our diagnostic recommendations are best-effort; you decide whether
              to act on them.
            </Section>

            <Section title="Data retention">
              We retain your account and session logs for as long as your account exists. You can request deletion at any
              time by writing to <strong>hello@yonsiigeeksupport.com</strong>. Some records (invoices, tax logs) may be
              retained for the period required by Indian law.
            </Section>

            <Section title="Your rights">
              You have the right to access, correct, export, or delete your personal data. We respond to verified
              requests within 30 days. Contact us at <strong>hello@yonsiigeeksupport.com</strong>.
            </Section>

            <Section title="Contact">
              Yonsii Geek Support · Dwarka, Delhi, India · hello@yonsiigeeksupport.com
            </Section>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-2xl font-extrabold text-slate-900 mb-3">{title}</h2>
      <div className="space-y-3 text-[15px]">{children}</div>
    </div>
  );
}
